import {
  funcScrollControl,
  funcLoad,
  topMain,
} from './index';

const funcEntry = (() => {


  funcScrollControl.noScroll();

  const pageTop = document.getElementById('pageTop');

  if (pageTop) {

    let sW = window.innerWidth;

    let jsSecBg = document.getElementById('jsSecBg');
    let videoBox = jsSecBg.querySelector('.js-video-box');
    let video
    // if (sW >= 750) {
    //   videoBox.innerHTML = '<video preload="metadata" loop muted playsinline controlslist="nodownload" disablepictureinpicture oncontextmenu="return false;" src="https://www.hoo-video.com/dh-naha-tsuboya/top_main.mp4" class="js-video"></video>';
    //   video = jsSecBg.querySelector(".js-video")
    // } else {
    //   videoBox.innerHTML = '<video preload="metadata" loop muted playsinline controlslist="nodownload" disablepictureinpicture oncontextmenu="return false;" src="https://www.hoo-video.com/dh-naha-tsuboya/top_main_sp.mp4" class="js-video-sp"></video>';
    //   video = jsSecBg.querySelector(".js-video-sp")
    // }
    videoBox.innerHTML = '<video preload="metadata" loop muted playsinline controlslist="nodownload" disablepictureinpicture oncontextmenu="return false;" src="https://www.hoo-video.com/dh-naha-tsuboya/top_main_2.mp4" class="js-video"></video>';
    video = jsSecBg.querySelector(".js-video")

    // console.log(video);

    video.load()

    video
      .play()
      .then(() => {
        funcLoad()
        topMain()
        console.log("video play");
      })
      .catch((error) => {
        funcLoad()
        topMain()
        console.log("video no play");
      });

  } else {

    document.addEventListener("DOMContentLoaded", () => {
      funcLoad()
    });

  }


})();
export default funcEntry;